<div class="flex flex-col flex-auto min-w-0">

    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">
        <ng-container *ngIf="!readOnly">
            <form [formGroup]="form">
                <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-around stretch"
                     fxLayoutAlign.sm="space-around stretch" fxLayoutAlign.xs="space-around stretch">
                    <mat-form-field appearance="outline" fxFlex="33%" class="px-4">
                        <mat-label>Estado</mat-label>
                        <input matInput cleanWhiteSpace formControlName="estado" [maxLength]="75"
                               [required]="form.get('estado').errors !== null && form.get('estado').errors.required"
                               readonly
                        >
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex.xs="100%" fxFlex.sm="33%" class="px-4">
                        <mat-select placeholder="Seleccionar criterio" (selectionChange)="onFiltroChange($event)"
                                    #selectFiter>
                            <mat-option>Limpiar...</mat-option>
                            <ng-container *ngFor="let filter of filters;">
                                <mat-option [value]="filter.id">{{filter.title}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                    <div fxFlex.xs="100%" fxFlex="33%">
                        <mat-form-field *ngIf='filtroSeleccionado == "municipio"' appearance="outline" class="px-4">
                            <mat-label>Municipio</mat-label>
                            <input matInput cleanWhiteSpace formControlName="municipio" [maxLength]="75"
                                   [required]="form.get('municipio').errors !== null && form.get('municipio').errors.required"
                            >
                        </mat-form-field>
                        <mat-form-field *ngIf='filtroSeleccionado == "cp"' appearance="outline" class="px-4">
                            <mat-label>CP</mat-label>
                            <input matInput cleanWhiteSpace formControlName="cp" [maxLength]="75"
                                   [required]="form.get('cp').errors !== null && form.get('cp').errors.required"
                            >
                        </mat-form-field>
                    </div>
                </div>
            </form>
            <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-around stretch"
                 fxLayoutAlign.sm="space-around stretch" fxLayoutAlign.xs="space-around stretch"
                 style="margin-bottom: 16px;">
                <button mat-button color="primary" (click)="buscarLocalizacion()" disabled='{{searchValid()}}'>Localizar
                    en mapa
                </button>
            </div>
        </ng-container>
        <evk-mapas></evk-mapas>

    </div>

</div>
